@if (isLoader()) {
  <app-loader></app-loader>
}
<div class="report-card" (click)="routeToReport()" tabindex="0" (keydown.enter)="routeToReport()">
  <div class="card-top">
    <img [src]="report.iconImg" alt="Report Icon" />
    <div class="card-title">{{ report.name }}</div>
  </div>
  <label
    class="card-bottom"
    (click)="$event.stopImmediatePropagation()"
    (keydown.enter)="$event.stopImmediatePropagation()"
  >
    <p>{{ 'Reporting.find.autoGenerate' | translate }}</p>
    <label class="slide-toggle-box">
      <input
        [checked]="report.hasAutoGenerate"
        (click)="activateDeactivateSubscription(report)"
        type="checkbox"
        id="autoGenerateAuthReport"
      />
      <span class="slide-toggle"></span>
    </label>
  </label>
</div>
